// @ts-nocheck
import { ButtonIcon } from "@insite/mobius/Button/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { ButtonType, ButtonVariant } from "@toolkit/Framework/Types/Button";
import { buttonThemeStyles, focusStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export const buttonStyles = (type: ButtonType) => {
    return css`
        ${focusStyles()}
        ${buttonDisabledStyles(type)}
        height: auto;
        min-width: ${pxToRem(100)};
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: ${pxToRem(10)} ${pxToRem(20)};
        transition: ${transitionHoverStyles("color", "background-color", "border-color")};

        ${({ theme }) => `
            font-weight: ${theme.design.typography.weight.bold};
            line-height: ${theme.design.typography.lineHeight.small};
        `}

        [class*="ButtonIcon"] {
            top: 0;
            height: 1em;

            svg {
                position: absolute;
                top: 50%;
                left: 50%;
                max-width: 100%;
                transform: translate3d(-50%, -50%, 0);
            }
        }
    `;
};

export const buttonDisabledStyles = (type: ButtonType) => {
    const baseDisabledButtonStyles = css`
        [class*="ButtonIcon"] {
            color: inherit;
        }
    `;
    switch (type) {
        case "solid":
            return css`
                &:disabled {
                    color: ${getColor("text.main")};
                    background-color: ${getColor("common.disabled")};
                    border-color: ${getColor("common.disabled")};
                    ${baseDisabledButtonStyles}
                }
            `;
        case "outline":
            return css`
                &:disabled {
                    color: ${getColor("text.main")};
                    background-color: ${getColor("common.background")};
                    border-color: ${getColor("common.disabled")};
                    ${baseDisabledButtonStyles}
                }
            `;
        default:
            break;
    }
};

export const checkoutButtonsStyles = () => {
    return css`
        ${({ theme }) => theme.button.primary.css}
        display: flex;
        align-items: center;
        justify-content: center;
        /* Bunzl custom code */
        padding: ${pxToRem(5)} ${pxToRem(12)};
        width: 100%;
        border-radius: ${pxToRem(6)};

        ${ButtonIcon} {
            top: 0;
            margin-right: ${pxToRem(5)};
        }
    `;
};

export interface StoreThemeButtonProps {
    variant?: string;
    type?: string;
    shape?: string;
    animation?: string;
}

export const buttonResetHoverStyles = () => {
    return css`
        &:hover,
        &:active {
            background-color: transparent;
        }
    `;
};

export const buttonResetStyles = (resetHover = true) => {
    return css`
        ${focusStyles()}
        min-width: 0;
        min-height: 0;
        padding: 0;
        border: 0;
        border-radius: 0;
        background-color: transparent;
        text-transform: inherit;
        font-size: inherit;
        font-weight: inherit;
        line-height: inherit;

        ${resetHover
            ? css`
                  &:hover,
                  &:active {
                      background-color: transparent;
                  }
              `
            : null}

        ${TypographyStyle} {
            font-size: inherit;
            font-weight: inherit;
        }

        ${IconWrapper} {
            color: inherit;
        }
    `;
};

export const buttonFieldIconStyles = () => {
    return css`
        ${({ theme }) => {
            if (theme.design.button.field.enabled) {
                const scale = 1 + theme.design.button.field.scaling;
                const align = 50 * (1 - theme.design.button.field.scaling);

                return css`
                    &:not(#important) {
                        top: 50%;
                        left: 50%;
                        right: auto;
                        display: block;
                        width: auto;
                        height: auto;
                        padding: 0;
                        background-color: transparent;
                        color: inherit;
                        line-height: 0;
                        transform: scale(${scale}) translate3d(-${align}%, -${align}%, 0);
                    }
                `;
            }
        }}
    `;
};

export const buttonFieldIconClickableStyles = (variant?: ButtonVariant) => {
    return css`
        ${({ theme }) => {
            if (theme.design.button.field.enabled) {
                return css`
                    &:not(#important) {
                        ${buttonThemeStyles(variant)}
                        min-width: auto;
                        height: 100%;
                        border: 0;

                        ${({ theme }) => css`
                            ${focusStyles(true)}
                            transform: scale(${1 - theme.design.button.field.scaling});
                        `}
                    }
                `;
            }
        }}
    `;
};
